import { useEffect, useState } from 'react';
import { MantineProvider, DirectionProvider } from '@mantine/core';
import { RouterProvider } from 'react-router-dom';
import router from '@/routes/AppRoutes';
import { ContentProvider } from '@/contexts/ContentContext';
import { resolver, theme } from './services/mantine';
import i18n from './services/i18n';
import Loading from './components/Loading';

const App = () => {
  const [isReady, setIsReady] = useState(false);

  useEffect(() => {
    if (i18n.isInitialized) {
      setIsReady(true);
    } else {
      i18n.on('initialized', () => setIsReady(true));
    }
  }, []);

  if (!isReady) return (<Loading />);

  return (
    <MantineProvider theme={theme} cssVariablesResolver={resolver}>
      <DirectionProvider>
        <ContentProvider>
          <RouterProvider router={router} />
        </ContentProvider>
      </DirectionProvider>
    </MantineProvider>
  );
};

export default App;
